import { AfterViewInit, Component, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { StudentService } from '../../data-access/services/student.service';
import { UniversityStudentDetails } from '../../../university-dashboard/data-access/models/student-details-model';
import { Roles } from '../../../authentication/data-access/models/auth.model';
import { UserStore } from '../../data-access/stores/user.store';
import { hasValidResults } from '../../utils/functions/checkData.function';
import { MatDialog } from '@angular/material/dialog';
import { AlterDetailsDialogComponent } from '../alter-details-dialog/alter-details-dialog.component';
import { Form, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SnackBarMessage } from '../../enums/snackBarMessage';
import { SnackBarDuration } from '../../enums/snackBarDuration';
import { UploadProfilePictureComponent } from '../upload-profile-picture/upload-profile-picture.component';
import { FileDownloadService } from '../../../university-dashboard/data-access/services/file-download-service.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { reloadComponent } from '../../utils/functions/reloadComponent';
import { DialogTitles } from '../../enums/dialog-titles';
import { documentTypeName } from '../../../university-dashboard/enums/documentType.model';
import { StatusEnum } from '../../enums/statusEnum';
import { DialogDimensions } from '../../enums/dialogDimensions';
import { filter, switchMap } from 'rxjs';
import { DocumentStatus } from "../../enums/documentStatus";

@Component({
    selector: 'app-personal-details',
    templateUrl: './personal-details.component.html',
    styleUrls: [
        './personal-details.component.scss',
        '../../../university-dashboard/ui/student-details/student-details.component.scss',
        '../../utils/styling/sharedStudentDetails.scss'
    ],
    standalone: false
})
export class PersonalDetailsComponent implements AfterViewInit {
  @Input() applicationGuid: string = '';
  @Input() student!: UniversityStudentDetails;
  @Output() studentDetailsChanged = new EventEmitter<boolean>();
  userRole!: Roles;
  isStudent: boolean = false;
  rolesEnum: typeof Roles = Roles;
  user!: any;
  profilePhotoUrl!: SafeUrl;
  defaultPhotoUrl = '../../../../assets/images/profile_photo.png';

  constructor(
    private userStore: UserStore,
    private studentService: StudentService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private fileDownloadService: FileDownloadService
  ) {
    this.isStudent = this.userStore.hasRole([this.rolesEnum.STUDENT]);
    this.userStore.get().subscribe((user) => {
      this.user = user;
    });
  }

  ngAfterViewInit(): void {
    this.loadProfileImage();
  }

  loadProfileImage(): void {
    if (this.student.profilephoto) {
      this.fileDownloadService.viewBlobFile(this.student.profilephoto).subscribe(url => {
        this.profilePhotoUrl = url;
      })
    } else {
      this.profilePhotoUrl = this.defaultPhotoUrl;
    }
  }

  edit(): void {
    const dialogRef = this.dialog.open(AlterDetailsDialogComponent, {
      width: '25rem',
      data: this.student
    });

    dialogRef.afterClosed().pipe(
      filter((result: FormGroup) => result.valid),
      switchMap((result: FormGroup) => {
        const updatedDetails = result.getRawValue();
        return this.studentService.updateStudentDetails(updatedDetails, this.student.applicationGuid)
      })
    ).subscribe((data) => {
        if (hasValidResults(data)) {
          this.studentDetailsChanged.emit(true);
          this.snackbar.open(SnackBarMessage.DETAILS_UPDATED, 'Dismiss', { duration: SnackBarDuration.DURATION })
        } else {
          this.snackbar.open(SnackBarMessage.ERROR_UPDATING_DETAILS, '', { duration: SnackBarDuration.DURATION });
        }
      });
  }

  openUpload(): void {
    const dialofRef = this.dialog.open(UploadProfilePictureComponent, {
      maxWidth: DialogDimensions.MAXWIDTH,
      maxHeight: DialogDimensions.MAXHEIGHT,
      width: DialogDimensions.WIDTH_FIFTY,
      data: {student:this.student, title:DialogTitles.UPDATE_PROFILE_PICTURE, documentType:documentTypeName.PROFILE_PICTURE}
    });
    dialofRef.afterClosed().subscribe((data:{studentId:number, file:string})=>{
      this.studentService.uploadStudentPhoto(data.studentId, data.file)
      .subscribe((data) => {
        if (hasValidResults(data)) {
          this.studentDetailsChanged.emit(true);
          this.snackBar.open(SnackBarMessage.UPLOAD_IMAGE_SUCCESS, '', { duration: SnackBarDuration.DURATION }).afterDismissed().subscribe(() => {
            reloadComponent(true,this.router);
          });
        } else {
          this.snackBar.open(SnackBarMessage.UPLOAD_IMAGE_FAILURE, '', { duration: SnackBarDuration.DURATION });
        }
      });
    })
  }

  shouldDisplayProfileSection(): boolean {
    return (this.student.status === StatusEnum.Approved && this.student.invoiceStatus === StatusEnum.Approved) ||
      this.student.status === DocumentStatus.APPLICATION_ACTIVE ||
      this.student.status === StatusEnum.Onboarded
  }
}
